/* eslint-disable no-unused-vars */
import React from 'react';
import { Link } from 'react-router-dom';

const LinkAnchor = (props) => {
    const { children, link, useAnchor, target, options, testId, 'data-testid': dataTestId, state } = props;
    const resolvedLink = link?.startsWith('app:') ? link.replace('app:', '') : link;

    // `state` is optional and additive: without it the Link receives the same bare string it
    // always has. When present, `pathname` MUST be included in the object — react-router 5 only
    // merges the current location for a *string* `to`, so an object without pathname renders
    // href="/". Left-click would still work, which is what makes that regression silent:
    // middle-click, Cmd-click and "Copy link address" would all land on the homepage.
    const to = state ? { pathname: resolvedLink, state } : resolvedLink;

    return (
        useAnchor ? (
            <a href={resolvedLink} target={target || `_self`} data-test={testId} data-testid={dataTestId}>{children}</a>
        ) : (
            <Link to={to} target={target || `_self`} data-test={testId} data-testid={dataTestId}>{children}</Link>
        )
    );
};

export default LinkAnchor;
